import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AccessCondition, AccessString, AuthService } from 'providers/auth.service';
import { distinctUntilChanged } from 'rxjs/operators';

@Pipe({ name: 'ceAccess', pure: false })
@UntilDestroy()
export class CeAccessPipe implements PipeTransform {
    allowed = false;
    hasRan = false;

    constructor(
        private authService: AuthService,
        private cdRef: ChangeDetectorRef
    ) {}

    /**
     *
     * @param accessString Single string or an array of strings.
     * @param condition Used when `accessString` is an array. Can be `OR` or `AND` defaults to 'AND'
     * @returns
     */
    transform(accessString: AccessString, condition: AccessCondition = 'AND') {
        if (!this.hasRan) {
            this.hasRan = true;

            this.authService
                .hasAccessTo$(accessString, condition)
                .pipe(distinctUntilChanged(), untilDestroyed(this))
                .subscribe((allowed) => {
                    this.allowed = allowed;
                    this.cdRef.markForCheck();
                });
        }

        return this.allowed;
    }
}
